window.$ = window.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new bootstrap.Tooltip(tooltipTriggerEl)
})

import AOS from 'aos';
AOS.init();

//SMOOTH SCROLL ----------------------------------------------------------------
if (window.location.hash) { // Si j'ai une ancre dans l'url
	$('html, body').animate({ scrollTop: $(window.location.hash).offset().top - $('nav').height() - 20 }, 'slow');
}
var current = $('meta[name=current]').attr("content");
$("a[href^='" + current + "#']").on("click", function (e) { // Si je clique sur un lien avec une ancre
	$('html, body').animate({ scrollTop: $(e.target.hash).offset().top - $('nav').height() - 20 }, 'slow');
});

//BURGER NAVBAR ----------------------------------------------------------------
$('#navbar').on('show.bs.collapse', function () { $('.burger').addClass('active'); });
$('#navbar').on('hide.bs.collapse', function () { $('.burger').removeClass('active'); });

//TARGET _BLANK ----------------------------------------------------------------
var url = $('meta[name=landing]').attr("content");
$('a[href^="http"], a[href^="https"], a[href^="mailto"]').not("[href^='" + url + "']").attr("target", "_blank").attr("rel", "noopener dofollow");
$("a[href^='" + url + "/storage']").attr("target", "_blank").attr("rel", "noopener dofollow"); // Ajout du target blank pour les pièces jointes des articles

//DIV-LINK ---------------------------------------------------------------------
$(".div-link").on("click", function () {
	if ($(this).data("blank") == true) {
		window.open($(this).data("link"), '_blank');
	} else {
		window.location = $(this).data("link");
	}
});

//CLASS ACTIVE NAV -------------------------------------------------------------
var url = (location.pathname == "/") ? "" : location.pathname;
$('.navbar-nav a[href="' + location.origin + url + '"]').addClass('active');

// Ajout auto de l'étoile input required
$('input, select, textarea').each(function () {
	if (this.required) {
		$('label[for="' + $(this).attr('id') + '"]').append("<span class='text-danger'> *</span>");
	}
});

// Zoom photos réals
$('#modalZoom').on('show.bs.modal', function (event) {
	$('#modal-img').attr('src', $(event.relatedTarget).data('image'));
});
$('#modalZoom').on('click', function (event) {
	bootstrap.Modal.getInstance(this).hide();
 });

// MODAL psk c pa bo :
var isshow = localStorage.getItem('isshow');
if (isshow === null) {
	localStorage.setItem('isshow', 1);
	new bootstrap.Modal(document.getElementById('tempWebsite')).show()
}
